var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKakaopay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 21,
    viewBox: "0 0 51 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1599_1272)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.625 21H10.4648C4.71055 21 0.0449219 16.2985 0.0449219 10.5C0.0449219 4.70149 4.71055 0 10.4648 0H39.6509C45.4052 0 50.0708 4.70149 50.0708 10.5C50.0708 16.2985 45.3793 21 39.625 21Z",
    fill: "#FFEB00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7351 5.04102C8.59877 5.04102 6.05859 7.05221 6.05859 9.55967C6.05859 11.153 7.12132 12.5634 8.70245 13.3731L8.15813 15.4104C8.13221 15.4627 8.15813 15.541 8.20997 15.5933C8.23589 15.6194 8.28773 15.6455 8.31365 15.6455C8.33957 15.6455 8.39141 15.6194 8.41733 15.6194L10.7242 14.0522C11.0612 14.1044 11.3981 14.1306 11.761 14.1306C14.8974 14.1306 17.4375 12.0933 17.4375 9.61191C17.4375 7.05221 14.8974 5.04102 11.7351 5.04102Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2328 13.3209V16.2463H20.1592V5.45895H21.6107L21.8699 6.13806C22.3106 5.69403 22.9845 5.22388 24.0472 5.22388C26.069 5.22388 27.028 6.7388 27.028 9.22015C27.028 11.806 25.5506 13.4515 23.4251 13.4515C23.0104 13.4776 22.6994 13.4515 22.2328 13.3209ZM22.2328 7.20895V11.8582C22.3365 11.8843 22.6216 11.9104 22.9067 11.9104C24.3842 11.9104 24.9544 10.8657 24.9544 9.22015C24.9544 7.78358 24.5656 6.92164 23.3992 6.92164C22.9845 6.92164 22.5698 7.02612 22.2328 7.20895Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.512 8.51487H32.6784V8.25367C32.6784 7.39173 32.1859 6.99994 31.3564 6.99994C30.7084 6.99994 29.9049 7.18278 29.231 7.52233L28.6607 6.138C29.3865 5.61561 30.527 5.27606 31.5379 5.27606C33.5078 5.27606 34.5965 6.32084 34.5965 8.33203V13.2686H33.1449L32.9376 12.6156C32.1081 13.2164 31.3305 13.4776 30.6566 13.4776C29.1532 13.4776 28.2979 12.5634 28.2979 11.0223C28.2979 9.37681 29.4124 8.51487 31.512 8.51487ZM32.7043 11.2574V9.82084H31.7452C30.6825 9.82084 30.1382 10.2126 30.1382 10.9701C30.1382 11.5447 30.4233 11.832 31.0454 11.832C31.6156 11.8582 32.3414 11.5708 32.7043 11.2574Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.869 12.4589C40.1433 14.3918 39.2879 15.8022 38.0178 16.5858L36.7477 15.4104C37.4735 14.7575 38.0178 14.1306 38.4585 13.2948L35.7109 5.74626L37.7586 5.19775L39.5212 11.3097L41.2579 5.17163L43.2796 5.74626L40.869 12.4589Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1599_1272"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 21,
    fill: "white",
    transform: "translate(0.0449219)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKakaopay);
export default __webpack_public_path__ + "static/media/kakaopay.06b56d8e56d16bba7a79866634658fa4.svg";
export { ForwardRef as ReactComponent };